import { render, staticRenderFns } from "./qiTa.vue?vue&type=template&id=6050245c&scoped=true&"
import script from "./qiTa.vue?vue&type=script&lang=js&"
export * from "./qiTa.vue?vue&type=script&lang=js&"
import style0 from "./qiTa.vue?vue&type=style&index=0&id=6050245c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6050245c",
  null
  
)

export default component.exports